import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import( '../views/HomeView.vue')
	},
	
	//Admin
	{
		path: '/checkinout',
		name: 'checkinout',
		component: () => import( '../views/CheckinoutView.vue')
	},{
		path: '/gestione-calendario',
		name: 'gestione-calendario',
		component: () => import( '../views/CalendarView.vue')
	},{
		path: '/ricerca',
		name: 'ricerca',
		component: () => import( '../views/SearchView.vue')
	},{
		path: '/gestione-eventi',
		name: 'gestione-eventi',
		component: () => import( '../views/EventsView.vue')
	},{
		path: '/ordini',
		name: 'ordini',
		component: () => import( '../views/OrdersView.vue')
	},
	
	//User
	{
		path: '/prenotazioni',
		name: 'prenotazioni',
		component: () => import( '../views/UserCheckinoutView.vue')
	},{
		path: '/calendario',
		name: 'calendario',
		component: () => import( '../views/UserCalendarView.vue')
	},{
		path: '/info',
		name: 'info',
		component: () => import( '../views/UserInfoView.vue')
	},{
		path: '/eventi',
		name: 'eventi',
		component: () => import( '../views/UserEventsView.vue')
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return { top: 0 }
	},
})

router.afterEach((to, from) => {
	let start_index = routes.findIndex( r => r.name == from.name );
	let end_index = routes.findIndex( r => r.name == to.name );
	
	to.meta.transition = start_index <= end_index ? 'slideright' : 'slideleft';
})


export default router
